// TODO - remove becouse of legacy

import { Selector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { AdSpendRow } from '../types'

export const listRowsSelector: Selector<ReduxState, AdSpendRow[] | null> = (state) => state.adSpends.listRows
export default listRowsSelector
